import React, { useState, useRef } from 'react'
import { Swiper } from 'swiper/react'
import SwiperCore from 'swiper'
import styled from 'styled-components'

import LegacyButton from 'components/LegacyButton'

import { Keyboard, Pagination, Navigation } from 'swiper/modules'

import { color } from 'styles/colors'

import { screenSize } from 'styles/shared'

type Props={
  children: React.ReactNode;
  closeCallback: (string) => void
}

const Carousel = ({ children, closeCallback }: Props) => {
  const swiperRef = useRef<SwiperCore>()
  const [isEnd, setIsEnd] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)

  return (
    <Swiper
      spaceBetween={30}
      pagination={{
        clickable: true
      }}
      keyboard={{
        enabled: true
      }}
      onBeforeInit={(swiper) => {
        swiperRef.current = swiper
      }}
      onAfterInit={(swiper) => {
        setIsEnd(swiper.isEnd)
        setCurrentIndex(swiper.activeIndex)
      }}
      onActiveIndexChange={(e) => {
        setIsEnd(e.isEnd)
        setCurrentIndex(e.activeIndex)
      }}
      modules={[Keyboard, Pagination, Navigation]}
      className="Carousel"
    >
      {children}
      <S.ButtonContainer>
        <S.CancelButton type="button" variant="secondary" onClick={() => closeCallback(currentIndex === 0 ? 'Skip' : 'Finish')} > {currentIndex === 0 ? 'Skip' : 'Finish'}</S.CancelButton>
        <LegacyButton disabled={isEnd} onClick={() => swiperRef.current?.slideNext()} type="button" variant="primary">Next</LegacyButton>
      </S.ButtonContainer>
    </Swiper>
  )
}

export default Carousel

const S = {
  ButtonContainer: styled.div`
    display: flex;
    justify-content: end;
    gap: 10px;
    position: relative;
    z-index: 100;
    float: right;

    @media ${screenSize.small} {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background: ${color('paneBackground')};
      padding: 10px;
      box-shadow: 0 -2px 6px ${color('shadowSubtle')};
    }
  `,
  CancelButton: styled(LegacyButton)`
    border-color:  ${color('cancelButtonBorder')};
    color:  ${color('cancelButtonText')};

    &:hover{
      border-color:  ${color('cancelButtonHoverBorder')};
      color:  ${color('cancelButtonHoverText')};
    }
  `
}
